import { useInfiniteQuery, keepPreviousData as previousPlaceholder } from '@tanstack/react-query';

import { ApiCollectionsResponse } from '../lib/api/Collections';

import { useApi } from '../contexts/ApiContext';

type UseCollectionsInfiniteOptions = Omit<
    Parameters<typeof useInfiniteQuery<ApiCollectionsResponse>>[0],
    'queryKey' | 'queryFn'
> & {
    keepPreviousData?: boolean;
};

export default function useCollectionsInfinite(
    query = null,
    opts: UseCollectionsInfiniteOptions = null,
) {
    const api = useApi();
    const { keepPreviousData = true } = opts || {};
    const { data = null, ...queryResult } = useInfiniteQuery({
        queryKey: ['collections', query],
        initialPageParam: 1,
        queryFn: ({ pageParam = 1, queryKey: [, queryParam], signal }) =>
            api.collections.get(queryParam, pageParam, null, { signal }),
        getNextPageParam: ({ pagination: { page: currentPage = 1, last_page: lastPage = -1 } }) => {
            if (lastPage === currentPage) {
                return undefined;
            }
            return currentPage + 1;
        },
        placeholderData: keepPreviousData ? previousPlaceholder : null,
        ...opts,
    });

    const { pages = null, pageParams = null } = data || {};

    return {
        pages,
        pageParams,
        ...queryResult,
    };
}
